import React from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';

export default ({selectedOtherInterval, setSelectedOtherInterval, responseData, handleIntervalChange_ }) => {

  const currentYear = new Date().getFullYear();
  const futureYears = Array.from({ length: 5 }, (_, index) => currentYear + index);

  //search by daily weekly data
  const data = {
    daily: {
      uData: responseData?.matchData?.res_data.length > 0 ? responseData?.matchData?.res_data : Array(31).fill(0),
      xLabels: Array.from({ length: 31 }, (_, index) => `Day ${index + 1}`),
    },
    weekly: {
      uData:responseData?.matchData?.res_data.length > 0 ? responseData?.matchData?.res_data : [0,0,0,0,0,0,0],
      xLabels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7"],
    },
    monthly: {
      uData:responseData?.matchData?.res_data.length > 0 ? responseData?.matchData?.res_data : [0,0,0,0,0,0,0,0,0,0,0,0],
      xLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    yearly: {
      uData: responseData?.matchData?.res_data.length > 0 ? responseData?.matchData?.res_data :  Array(futureYears.length).fill(0),
      xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
    },
  };

  const sizing = {
    margin: { right: 5},
    // width: 250, // Adjust width as needed
    height: 280, // Adjust height as needed
    legend: { hidden: true },
  };
   //for pie chart
   function convertData(originalData) {
    let convertedData = {
      data: []
    };

    originalData[selectedOtherInterval]?.uData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `Cancelled ${originalData[selectedOtherInterval]?.xLabels[index]}`, color:"#02B2AF",});
    });

    return convertedData;
  }
  const convertedData = convertData(data);

  return (
    <>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                  <div className="row">
                  <div className="d-flex align-items-center justify-content-between">
                      <h4 className=""><b> Number of cancelled matches</b></h4>
                    </div>
                  </div>
                  <div className="row">
                      <div className="col-md-6">
                        <BarChart
                           series={[
                              {
                                data: data[selectedOtherInterval]?.uData || [], // Provide a default empty array if uData is undefined
                                label: 'Cancel matches',
                                id: 'cancelmatchId',
                                color:"#02B2AF"
                              }
                            ]}
                            xAxis={[{ data: data[selectedOtherInterval]?.xLabels, scaleType: 'band' }]}
                            // width={550}
                            height={300}
                        />
                      </div>
                      <div className="col-md-6">
                        <PieChart
                          series={[
                            {
                              arcLabel: (item) => `${item.label} (${item.value})`,
                              arcLabelMinAngle: 45,
                              data : convertedData?.data
                            },
                          ]}
                          sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                              fill: 'white',
                              fontSize: 10,
                            },
                          }}
                          {...sizing}
                        />
                      </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </>
  );
};

